<template>
  <div class="container mainContent">
    <h2>Venue Information</h2>

    <h3>Address &amp; Contact Details</h3>
    <p>
      <a href="http://www.ccconferencecentre.co.za"><strong>Century City Conference Centre and Hotel</strong></a>
    </p>
    <address>
      No. 4 Energy Lane<br />
      Bridgeways Precinct<br />
      Century City<br />
      7441
    </address>

    <p>
      Tel nr: <a href="tel:+27212048000">+27 21 204 8000</a>
    </p>
    <p>
      Website: <a href="http://www.ccconferencecentre.co.za">http://www.ccconferencecentre.co.za</a>
    </p>

    <h3>Site Map</h3>
    <img src="../assets/img/venue-map.jpg"><br />

    <h3>Directions</h3>
    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3311.773802024184!2d18.502809315210943!3d-33.89547898064882!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1dcc5c112ae309a3%3A0x2e84748d4b1c112!2sCentury+City+Conference+Centre!5e0!3m2!1sen!2sza!4v1478123605580" width="1170" height="600" frameborder="0" style="border:0" allowfullscreen></iframe>


</template>

<script>
  export default {
    name: "info_venue"
  }
</script>



/** WEBPACK FOOTER **
 ** info_venue.vue?30b9ec18
 **/